import { defineStore } from 'pinia';
import { createPopulateString } from '~/utils/strapiComponents/addStrapiData';
import { strapi } from '../transport/strapi';
import type {
  IPaymentSystemSortingData,
  IPaymentSystemSortingStrapiResponse,
} from '~/types/payments';

export const useStorePaymentSystemSorting = defineStore('paymentSystemSorting', {
  state: () => ({
    data: [] as IPaymentSystemSortingData[],
    requestPromise: null as Promise<IPaymentSystemSortingStrapiResponse> | null,
  }),

  getters: {
    depositSortingData(): IPaymentSystemSortingData[] {
      return this.data.filter((item) => !item.isForWithdraw);
    },
    withdrawSortingData(): IPaymentSystemSortingData[] {
      return this.data.filter((item) => item.isForWithdraw);
    },
  },

  actions: {
    async loadPaymentSystemSortingData(): Promise<boolean> {
      if (!this.requestPromise) {
        const populateString = createPopulateString(['paymentSystems']);

        this.requestPromise = strapi()
          .get('payment-system-sortings', populateString)
          .finally(() => (this.requestPromise = null));
      }

      const response = await this.requestPromise;

      if (response?.data) {
        const filteredState = this.data.filter(
          (item) => !response.data.find(({ id }) => id && id === item.id)
        );

        this.data = [...filteredState, ...response.data];

        return true;
      } else {
        return false;
      }
    },
  },
});
